
import {BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Component, NgModule} from '@angular/core';
import {CustomMaterialModule } from './core/material.module';
import {AppRoutingModule } from './core/app.routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent } from './app.component';
import {QueryList} from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {GlobalEventsManager} from './GlobalEventManager';
import {EnvServiceProvider} from './env.service.provider';
import {MyHttpInterceptor} from './Interceptors/HttpInterceptor';
import {TokenGuard} from './Interfaces/TokenGuard';
import { LoginComponent } from './AppScreens/login/login.component';
import { MenusComponent } from './AppScreens/menus/menus.component';
import { ForgotPasswordComponent } from './AppScreens/forgot-password/forgot-password.component';
import { NewUserComponent } from './AppScreens/new-user/new-user.component';
import { ChartsComponent } from './AppScreens/charts/charts.component';
import {ImportContainersComponent} from './AppScreens/import-containers/import-containers.component';
import { ConfirmationDialogComponent } from './Component/confirmation-dialog/confirmation-dialog.component';
import { GateActivityComponent } from './AppScreens/gate-activity/gate-activity.component';
import { UtcsInquiryComponent } from './AppScreens/utcs-inquiry/utcs-inquiry.component';
import { DetentionClaimInquiryComponent } from './AppScreens/detention-claim-inquiry/detention-claim-inquiry.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import { RpmInspectionsComponent } from './AppScreens/rpm-inspections/rpm-inspections.component';
import { BookingInquiryComponent } from './AppScreens/booking-inquiry/booking-inquiry.component';
import { EnterPasscodeComponent } from './AppScreens/enter-passcode/enter-passcode.component';
import {CountdownModule} from 'ngx-countdown';
import { PeelOffPileComponent } from './AppScreens/peel-off-pile/peel-off-pile.component';
import { EquipmentInquiryComponent } from './AppScreens/equipment-inquiry/equipment-inquiry.component';
import { SealinkInquiryComponent } from './AppScreens/sealink-inquiry/sealink-inquiry.component';
import { ImportExportChargesComponent } from './AppScreens/import-export-charges/import-export-charges.component';
import {ChargesCalculatorComponent} from './AppScreens/charges-calculator/charges-calculator.component';
import { NotificationsComponent } from './AppScreens/notifications/notifications.component';
import { ApiSubscriptionComponent } from './AppScreens/api-subscription/api-subscription.component';
import { AccountProfileComponent } from './AppScreens/account-profile/account-profile.component';
import { SubUsersComponent } from './AppScreens/sub-users/sub-users.component';
import { ReportsComponent } from './AppScreens/reports/reports.component';
import { PhoneMaskDirective } from './phone-mask.directive';
import { ContactInfoComponent } from './AppScreens/contact-info/contact-info.component';
import { VesselScheduleComponent } from './AppScreens/vessel-schedule/vessel-schedule.component';
import { EmptyReceivingComponent } from './AppScreens/empty-receiving/empty-receiving.component';
import { UnderMaintComponent } from './AppScreens/under-maint/under-maint.component';
import { DriverHomepageComponent } from './AppScreens/driver-homepage/driver-homepage.component';
import { EmailReportsComponent } from './AppScreens/email-reports/email-reports.component';
import {environment} from '../environments/environment';
import {ServiceWorkerModule, SwUpdate} from '@angular/service-worker';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSliderModule} from '@angular/material/slider';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatSortModule} from '@angular/material/sort';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {MatBottomSheet, MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatRadioModule} from '@angular/material/radio';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSidenavModule} from '@angular/material/sidenav';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgxBarcode6Module} from 'ngx-barcode6';

import {BaseChartDirective, NgChartsModule, ThemeService} from 'ng2-charts';
import { Chart, registerables } from 'chart.js';



@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        MenusComponent,
        ForgotPasswordComponent,
        NewUserComponent,
        ChartsComponent,
        ImportContainersComponent,
        ConfirmationDialogComponent,
        GateActivityComponent,
        UtcsInquiryComponent,

        DetentionClaimInquiryComponent,
        RpmInspectionsComponent,
        BookingInquiryComponent,
        EnterPasscodeComponent,
        PeelOffPileComponent,
        EquipmentInquiryComponent,
        SealinkInquiryComponent,
        ImportExportChargesComponent,
        ChargesCalculatorComponent,
        NotificationsComponent,
        ApiSubscriptionComponent,
        AccountProfileComponent,
        SubUsersComponent,
        ReportsComponent,
        PhoneMaskDirective,

    ContactInfoComponent,
        VesselScheduleComponent,
        EmptyReceivingComponent,
        UnderMaintComponent,
        DriverHomepageComponent,
        EmailReportsComponent,
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        MatTooltipModule,
      NgChartsModule ,
        MatSliderModule,
        BrowserAnimationsModule,
        CustomMaterialModule,
        FormsModule,
        DragDropModule,
        AppRoutingModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatSidenavModule,

        MatExpansionModule,
        MatPaginatorModule,
        MatFormFieldModule,
    NgxBarcode6Module,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSortModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatStepperModule,
        ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
        MatTabsModule, MatBottomSheetModule, MatBadgeModule,MatDatepickerModule,
        MatNativeDateModule, CountdownModule , MatRadioModule, MatButtonToggleModule], providers: [EnvServiceProvider, SwUpdate, GlobalEventsManager, TokenGuard, MatBottomSheet, ThemeService, QueryList,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MyHttpInterceptor,
            multi: true
        }, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule {





}
